'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var tslib_es6 = require('./tslib.es6-fe93d37b.js');
var React = require('react');
var React__default = _interopDefault(React);
var styled = require('styled-components');
var styled__default = _interopDefault(styled);

var Container = styled__default.div(templateObject_1 || (templateObject_1 = tslib_es6.__makeTemplateObject(["\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-start;\n"], ["\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-start;\n"])));
var StyledLabel = styled__default.div(templateObject_2 || (templateObject_2 = tslib_es6.__makeTemplateObject(["\n  font: ", ";\n  color: ", ";\n"], ["\n  font: ",
    ";\n  color: ", ";\n"])), function (_a) {
    var statusBold = _a.statusBold, textSize = _a.textSize, theme = _a.theme;
    return (statusBold ? 500 : 400) + "\n    " + (textSize || 14) + "px/24px " + theme.fonts.join();
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.fontColor;
});
var StyledMessage = styled__default.div(templateObject_3 || (templateObject_3 = tslib_es6.__makeTemplateObject(["\n  font: ", ";\n  color: ", ";\n  margin-left: 1ch;\n"], ["\n  font: ",
    ";\n  color: ", ";\n  margin-left: 1ch;\n"])), function (_a) {
    var messageBold = _a.messageBold, textSize = _a.textSize, theme = _a.theme;
    return (messageBold ? 500 : 400) + "\n    " + (textSize || 14) + "px/24px " + theme.fonts.join();
}, function (_a) {
    var theme = _a.theme, statusMessageColor = _a.statusMessageColor;
    return statusMessageColor || theme.colors.fontColor;
});
var templateObject_1, templateObject_2, templateObject_3;

var StatusMessage = function (_a) {
    var statusTitle = _a.statusTitle, statusMessage = _a.statusMessage, statusBold = _a.statusBold, messageBold = _a.messageBold, textSize = _a.textSize, statusMessageColor = _a.statusMessageColor;
    return (React__default.createElement(Container, { "data-testid": "status-message" },
        React__default.createElement(StyledLabel, { statusBold: statusBold, textSize: textSize }, statusTitle),
        React__default.createElement(StyledMessage, { messageBold: messageBold, textSize: textSize, statusMessageColor: statusMessageColor }, statusMessage)));
};
StatusMessage.defaultProps = {
    statusBold: true,
    messageBold: false,
    textSize: 14,
};

exports.StatusMessage = StatusMessage;
